import { Card, Input, Row, Col, Button, DatePicker, Form, Alert, Select, AutoComplete } from "antd";
import { useState, useEffect } from "react";
import { backendURL } from "../Globals";

const { Option } = Select;

const departamentos = [
  { nombre: 'Administración de Empresas', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Bioquímica y Biología Molecular', rama: 'Ciencias' },
  { nombre: 'Biología de Organismos y Sistemas', rama: 'Ciencias' },
  { nombre: 'Biología Funcional', rama: 'Ciencias' },
  { nombre: 'Ciencia de los Materiales e Ingeniería Metalúrgica', rama: 'Ingeniería y Arquitectura' },
  { nombre: 'Ciencia y Tecnología Náutica', rama: 'Ingeniería y Arquitectura' },
  { nombre: 'Cirugía y Especialidades Médico Quirúrgicas', rama: 'Ciencias de la Salud' },
  { nombre: 'Construcción e Ingeniería de Fabricación', rama: 'Ingeniería y Arquitectura' },
  { nombre: 'Contabilidad', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Derecho Privado y de la Empresa', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Derecho Público', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Economía', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Economía Aplicada', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Economía Cuantitativa', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Estadística e Investigación Operativa y Didáctica de la Matemática', rama: 'Ciencias' },
  { nombre: 'Explotación y Prospección de Minas', rama: 'Ingeniería y Arquitectura' },
  { nombre: 'Filología Clásica y Románica', rama: 'Artes y Humanidades' },
  { nombre: 'Filología Española', rama: 'Artes y Humanidades' },
  { nombre: 'Filología Inglesa, Francesa y Alemana', rama: 'Artes y Humanidades' },
  { nombre: 'Filosofía', rama: 'Artes y Humanidades' },
  { nombre: 'Física', rama: 'Ciencias' },
  { nombre: 'Geografía', rama: 'Artes y Humanidades' },
  { nombre: 'Geología', rama: 'Ciencias' },
  { nombre: 'Historia', rama: 'Artes y Humanidades' },
  { nombre: 'Historia del Arte y Musicología', rama: 'Artes y Humanidades' },
  { nombre: 'Ingeniería Eléctrica, Electrónica, de Comunicaciones y Sistemas', rama: 'Ingeniería y Arquitectura' },
  { nombre: 'Ingeniería Química y Tecnología del Medio Ambiente', rama: 'Ingeniería y Arquitectura' },
  { nombre: 'Informática', rama: 'Ingeniería y Arquitectura' },
  { nombre: 'Matemáticas', rama: 'Ciencias' },
  { nombre: 'Medicina', rama: 'Ciencias de la Salud' },
  { nombre: 'Morfología y Biología Celular', rama: 'Ciencias' },
  { nombre: 'Psicología', rama: 'Ciencias de la Salud' },
  { nombre: 'Química Física y Analítica', rama: 'Ciencias' },
  { nombre: 'Química Orgánica e Inorgánica', rama: 'Ciencias' },
  { nombre: 'Sociología', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Ciencias de la Educación', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Ciencias Jurídicas Básicas', rama: 'Ciencias Sociales y Jurídicas' },
  { nombre: 'Energía', rama: 'Ingeniería y Arquitectura' }
];

const ramas = Array.from(new Set(departamentos.map(dep => dep.rama)));

const AddComponent = () => {
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // Estado para el tipo de mensaje
  const [selectedRama, setSelectedRama] = useState("");
  const [journals, setJournals] = useState([]);
  const [selectedJournal, setSelectedJournal] = useState({});
  const [editors, setEditors] = useState([]); // Estado para los editores

  useEffect(() => {
    const fetchJournals = async () => {
      let response = await fetch(backendURL + "/journals?apiKey=" + localStorage.getItem("apiKey"));
      if (response.ok) {
        let data = await response.json();
        setJournals(data);
      }
    };

    const fetchEditors = async () => {
      let apiKey = localStorage.getItem("apiKey");

      let response = await fetch(`${backendURL}/articles/editors`, { // 🔹 Quita la coma aquí
          method: "GET",
          headers: {
              "Authorization": `Bearer ${apiKey}`,
              "Content-Type": "application/json"
          }
      });
  
      if (response.ok) {
          let data = await response.json();
          console.log("Editores obtenidos del backend:", data);
          setEditors(data.map(editor => editor.name));
      } else {
          console.error("Error al obtener editores:", response.status);
      }
  };
  

    fetchJournals();
    fetchEditors();
  }, []);

  const handleDepartamentoChange = (value) => {
    const departamento = departamentos.find(dep => dep.nombre === value);
    if (departamento) {
      setSelectedRama(departamento.rama);
    } else {
      setSelectedRama("");
    }
  };

  const handleJournalSelect = (value) => {
    const journal = journals.find(j => j.title === value);
    if (journal) {
      setSelectedJournal(journal);
    } else {
      setSelectedJournal({});
    }
  };

  const onFinish = async (values) => {
    console.log('Success:', values);

    const formattedValues = {
        ...values,
        fechaEnvio: values.fechaEnvio ? values.fechaEnvio.format('YYYY-MM-DD') : undefined,
        fechaAceptacion: values.fechaAceptacion ? values.fechaAceptacion.format('YYYY-MM-DD') : undefined,
        fechaSolicitud: values.fechaSolicitud ? values.fechaSolicitud.format('YYYY-MM-DD') : undefined,
        fechaAprobacion: values.fechaAprobacion ? values.fechaAprobacion.format('YYYY-MM-DD') : undefined,
        pIssn: selectedJournal.issn,
        eIssn: selectedJournal.e_issn,
    };

    try {
        let response = await fetch(`${backendURL}/articles`, {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("apiKey")}`  // ✅ API Key en headers
            },
            body: JSON.stringify(formattedValues),
        });

        if (response.ok) {
            setMessage("Nuevo artículo añadido correctamente");
            setMessageType("success");
        } else {
            let jsonData = await response.json();
            setMessage(jsonData.error + " error");
            setMessageType("error");
        }
    } catch (error) {
        setMessage("Error de red. Por favor, inténtelo de nuevo.");
        setMessageType("error");
    }
};


  return (
    <Row align="middle" justify="center" style={{ minHeight: "70vh", paddingTop: "2cm" }}>
      <Col>
        {message && (
          <Alert
            type={messageType}
            message={message}
            style={{ marginBottom: "20px" }}
            showIcon
          />
        )}
        <Card title="Añadir nuevo artículo aceptado" style={{ width: "800px" }}>
          <Form
            name="add_article"
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="titulo"
                  label="Título"
                  rules={[{ required: true, message: 'Por favor ingrese el título' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="doi"
                  label="DOI"
                  rules={[{ required: true, message: 'Por favor ingrese el DOI' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="autorLikeEditor"
                  label="Autor según editor"
                  rules={[{ required: true, message: 'Por favor ingrese el autor según editor' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="autorLikePortal"
                  label="Autor Normalizado"
                  rules={[{ required: true, message: 'Por favor ingrese el autor normalizado' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="idioma"
                  label="Idioma"
                  rules={[{ required: true, message: 'Por favor seleccione el idioma' }]}
                >
                  <Select placeholder="Seleccione el idioma">
                    <Option value="Inglés">Inglés</Option>
                    <Option value="Español">Español</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="departamento"
                  label="Departamento"
                  rules={[{ required: true, message: 'Por favor seleccione el departamento' }]}
                >
                  <Select
                    showSearch
                    placeholder="Seleccione un departamento"
                    optionFilterProp="children"
                    onChange={handleDepartamentoChange}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {departamentos.sort((a, b) => a.nombre.localeCompare(b.nombre)).map(departamento => (
                      <Option key={departamento.nombre} value={departamento.nombre}>
                        {departamento.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="ramaDepartamento"
                  label="Rama del departamento"
                >
                  <Select
                    placeholder="Seleccione la rama del departamento"
                    value={selectedRama}
                    readOnly
                  >
                    {ramas.map(rama => (
                      <Option key={rama} value={rama}>
                        {rama}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="revista"
                  label="Revista"
                  rules={[{ required: true, message: 'Por favor ingrese la revista' }]}
                >
                  <AutoComplete
                    options={journals.map(journal => ({ value: journal.title }))}
                    onSelect={handleJournalSelect}
                    filterOption={(inputValue, option) =>
                      option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                  >
                    <Input size="large" />
                  </AutoComplete>
                </Form.Item>
              </Col>
              <Col span={8}>
    <Form.Item
      name="pIssn"
      label="Print ISSN"
      rules={[{ required: true, message: 'Por favor ingrese el print ISSN' }]}
    >
      <Input size="large" value={selectedJournal.issn} />
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item
      name="eIssn"
      label="Electronic ISSN"
      rules={[{ required: true, message: 'Por favor ingrese el electronic ISSN' }]}
    >
      <Input size="large" value={selectedJournal.e_issn} />
    </Form.Item>
  </Col>
            </Row>
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name="tipologia"
                  label="Tipología"
                  rules={[{ required: true, message: 'Por favor ingrese la tipología' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={6}>
              <Form.Item
  name="editor"
  label="Editor"
  rules={[{ required: true, message: 'Por favor seleccione el editor' }]}
>
  <Select placeholder="Seleccione el editor">
    {editors.map((editor, index) => (
      <Option key={index} value={editor}>
        {editor}
      </Option>
    ))}
  </Select>
</Form.Item>

              </Col>
              <Col span={6}>
                <Form.Item
                  name="modelOa"
                  label="Modelo OA"
                  rules={[{ required: true, message: 'Por favor seleccione el modelo OA' }]}
                >
                  <Select placeholder="Seleccione el modelo OA">
                    <Option value="Full Open Access">Full Open Access</Option>
                    <Option value="Hybrid">Hybrid</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="licencia"
                  label="Creative Commons"
                  rules={[{ required: true, message: 'Por favor seleccione la licencia' }]}
                >
                  <Select placeholder="Seleccione la licencia">
                    <Option value="CC BY">CC BY</Option>
                    <Option value="CC BY-SA">CC BY-SA</Option>
                    <Option value="CC BY-ND">CC BY-ND</Option>
                    <Option value="CC BY-NC">CC BY-NC</Option>
                    <Option value="CC BY-NC-SA">CC BY-NC-SA</Option>
                    <Option value="CC BY-NC-ND">CC BY-NC-ND</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="fechaSolicitud"
                  label="Fecha de solicitud"
                  rules={[{ required: true, message: 'Por favor ingrese la fecha de solicitud' }]}
                >
                  <DatePicker size="large" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="fechaAprobacion"
                  label="Fecha de aprobación"
                  rules={[{ required: true, message: 'Por favor ingrese la fecha de aprobación' }]}
                >
                  <DatePicker size="large" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              
            </Row>
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name="precio"
                  label="Precio"
                  rules={[{ required: true, message: 'Por favor ingrese el precio' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="financiador"
                  label="Financiador"
                  rules={[{ required: true, message: 'Por favor ingrese el financiador' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="idFinanciador"
                  label="ID del Financiador"
                  rules={[{ required: true, message: 'Por favor ingrese el ID del financiador' }]}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={6}>
  <Form.Item
    name="periodo"
    label="Periodo"
    rules={[{ required: true, message: 'Por favor seleccione el periodo' }]}
  >
    <Select placeholder="Seleccione el periodo">
      {[
        new Date().getFullYear(), // Año en curso
        new Date().getFullYear() + 1 // Año siguiente
      ].map(year => (
        <Option key={year} value={year}>
          {year}
        </Option>
      ))}
    </Select>
  </Form.Item>
</Col>
            </Row>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Añadir
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default AddComponent;






